/* jslint esversion: 6 */
// import Vue from 'vue';
// import Vuex from 'vuex';
import login from './modules/login.js';
import tree from './modules/tree.js';
import modelManage from './modules/modelManage.js';
import basicInfo from './modules/basicInfo.js';
import warehouse from './modules/warehouse.js';
import modelview from './modules/modelview.js';
import viewpoint from './modules/viewpoint.js';

// Vue.use(Vuex);

// const store = new Vuex.Store({
//   modules: {
//     login,
//     tree,
//     modelManage,
//     basicInfo,
//     warehouse,
//     modelview,
//     viewpoint
//   }
// });
// window.$store = store;
// export default store;
export default function install(store) {
  store.registerModule('modelview', modelview);
  store.registerModule('basicInfo', basicInfo);
  store.registerModule('login', login);
  store.registerModule('tree', tree);
  store.registerModule('warehouse', warehouse);
  store.registerModule('viewpoint', viewpoint);
  store.registerModule('modelManage', modelManage);
}



// WEBPACK FOOTER //
// ./src/store/index.js